import { initializeApp, type FirebaseApp } from 'firebase/app';
import firebaseConfig from '../../firebase-applet-config.json';

/** Shared Firebase app instance (used by firebase.ts and GA4 analytics). */
export const app: FirebaseApp = initializeApp(firebaseConfig);
